import { useEffect, useState } from 'react';
import { archiveAdminEngagement, getAdminEngagements, saveAdminEngagement } from '../../lib/api';
import type { AdminEngagement, EngagementInput } from '../../lib/types';
import { EngagementForm } from '../components/EngagementForm';

export function EngagementsAdmin({ csrfToken }: { csrfToken: string }) {
  const [engagements, setEngagements] = useState<AdminEngagement[]>([]);
  const [editing, setEditing] = useState<AdminEngagement | null | 'new'>(null);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const load = () => getAdminEngagements().then(setEngagements).catch((reason: Error) => setError(reason.message));
  useEffect(() => { void load(); }, []);

  async function save(value: EngagementInput) {
    setPending(true); setError('');
    try { await saveAdminEngagement(value, csrfToken, editing === 'new' || !editing ? undefined : editing.id); setEditing(null); await load(); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'Unable to save engagement.'); }
    finally { setPending(false); }
  }

  async function archive(id: string) {
    setPending(true); setError('');
    try { await archiveAdminEngagement(id, csrfToken); await load(); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'Unable to archive engagement.'); }
    finally { setPending(false); }
  }

  return <><header className="admin-page-heading"><p className="admin-kicker">Content</p><h1>Engagements</h1><button type="button" onClick={() => setEditing('new')}>Add engagement</button></header>{error && <div className="admin-error" role="alert">{error}</div>}{editing && <EngagementForm engagement={editing === 'new' ? undefined : editing} pending={pending} onSubmit={save} onCancel={() => setEditing(null)} />}<div className="admin-table">{engagements.map((item) => <article key={item.id}><div><strong>{item.title}</strong><span>{item.dateLabel} · {item.organization}</span></div><div><button type="button" onClick={() => setEditing(item)}>Edit</button><button type="button" disabled={pending} onClick={() => archive(item.id)}>Archive</button></div></article>)}</div></>;
}
